import { Paper, Tab, Tabs } from "@material-ui/core";
import React, { useState } from "react";
import { DocsPanel, EventosPanel } from "../elements/panels";

const getFromEventos = (array, type) => {
  return array?.filter(({ attributes: { tipo } }) => tipo === type);
};

const MoreDataArea = ({ precatorio }) => {
  const [tabValue, setTabValue] = useState(0);
  const { processoOrigem, documentos, eventos } = precatorio;

  const handleChange = (_ev, newValue) => setTabValue(newValue);

  return (
    <Paper elevation={5} style={{ marginBottom: "24px" }}>
      <Tabs
        centered
        variant="fullWidth"
        indicatorColor="primary"
        value={tabValue}
        onChange={handleChange}
        aria-label="Abas com movimentações, publicações e documentos do precatório e do processo"
      >
        <Tab label="Documentos anexos" />
        <Tab label="Movimentações" />
        <Tab label="Publicações" />
      </Tabs>

      <DocsPanel
        docsPrecatorio={documentos}
        docsProcesso={processoOrigem?.documentos}
        value={tabValue}
        index={0}
      />

      <EventosPanel
        eventosPrecatorio={getFromEventos(eventos, "movimento_judicial")}
        eventosProcesso={getFromEventos(
          processoOrigem?.eventos,
          "movimento_judicial"
        )}
        value={tabValue}
        index={1}
      />

      <EventosPanel
        eventosPrecatorio={getFromEventos(eventos, "publicacao")}
        eventosProcesso={getFromEventos(processoOrigem?.eventos, "publicacao")}
        value={tabValue}
        index={2}
      />
    </Paper>
  );
};

export default MoreDataArea;
